export default "__VITE_ASSET__CBbLJ7r3__"